/*
 *  Manage user modal dialog
 */
angular.module('qkr').controller('UserManagmentModalDialogController',
    ($scope, $uibModal, $uibModalInstance, userManagementService, utils, userManagementContext, userAction,
     currentPartner, currentMerchant, editUserRecord, messageService, appConfig, gettextCatalog) => {

    $scope.userAction = userAction;
    $scope.roleList = userManagementContext.roles;
    $scope.partnerList = userManagementContext.partners;
    $scope.merchantList = userManagementContext.merchants;
    $scope.outletList = userManagementContext.outlets;
    $scope.selectedRoleList = [];
    $scope.form = {};
    $scope.user = {};
    $scope.editWebUserRole;
    $scope.saving = false;
    $scope.isNew = false;
    $scope.roleRule = getDefaultRoleRule();
    $scope.selectRoleFromList = true;
    $scope.selectPartnerFromList = false;
    $scope.selectMerchantFromList = false;
    $scope.selectOutletFromList = false;

    $scope.init = function() {
    	if (!utils.hasNoValue(userManagementContext.defaultRole) && $scope.roleList.length == 1) {
    		if ($scope.roleList[0].rolename == userManagementContext.defaultRole) {
    			$scope.selectRoleFromList = false;
    		}
    	}
    	
        if ($scope.userAction == 'edit') {	
            $scope.isNew = false;
            $scope.form.username = editUserRecord.username;
            $scope.form.originalName = editUserRecord.username;
            $scope.form.firstName = editUserRecord.firstName;
            $scope.form.lastName = editUserRecord.lastName;
            $scope.form.password = editUserRecord.password;
            $scope.form.openApiConsumerKey = editUserRecord.openApiClientId;

            $scope.form.role = getSelectedRole(editUserRecord.webUserRoles[0].rolename);
            $scope.processRoleRules($scope.form.role);
            
            if ($scope.roleRule.partnerRequired) {
            	$scope.form.partner = getSelectedPartner(editUserRecord.partner);
            }
            
            if ($scope.roleRule.merchantRequired) {
            	$scope.form.merchant = getSelectedMerchant(editUserRecord.merchant);
            }
            
            if ($scope.roleRule.outletRequired) {
            	$scope.form.outlet = getSelectedOutlet(editUserRecord.merchantLoc);
            }
        } else {
            $scope.isNew = true;
            
            if (!utils.hasNoValue(userManagementContext.defaultRole)) {
	        	$scope.form.role = getSelectedRole(userManagementContext.defaultRole);
	        	$scope.processRoleRules($scope.form.role);
            }
        }
    };
    
    $scope.processRoleRules = function(role) {
    	const roleRule = getDefaultRoleRule();
    	const activeRoleRule = userManagementContext.roleRules[role.rolename];
    	
    	if (activeRoleRule != null) {
    		if (String(activeRoleRule.partnerRequired) == 'true') {
    			roleRule.partnerRequired = true;
    			
    			if (currentPartner != null) {
    				$scope.form.partner = currentPartner;
    			} else {
    				$scope.selectPartnerFromList = true;
    			}
    		}
    		
    		if (String(activeRoleRule.merchantRequired) == 'true') {
    			roleRule.merchantRequired = true;
    			
    			if (currentMerchant != null) {
    				$scope.form.merchant = currentMerchant;
    			} else {
    				$scope.selectMerchantFromList = true;
    			}
    		}
    		
    		if (String(activeRoleRule.outletRequired) == 'true') {
    			roleRule.outletRequired = true;
    			$scope.selectOutletFromList = true;
    		}
    		
    		if (String(activeRoleRule.usernameAndPasswordOnly) == 'true') {
    			roleRule.usernameAndPasswordOnly = true;
    		}
    		
    		if (String(activeRoleRule.dontSendActivationEmail) == 'true') {
    			roleRule.dontSendActivationEmail = true;
    		}
    	}
    	
    	$scope.roleRule = roleRule;
    	clearNonRequiredObjects();
    };

    $scope.createUser = function(isNew) {
        $scope.createForm.$setSubmitted();

        if(!$scope.createForm.$valid) {
            return;
        }

        $scope.saving = true;

        if (!isNew) {
            userManagementService.updateUserPost($scope.form).then((response) => {
                if (response.status == 200) {
                    $uibModalInstance.close('done');
                } else {
                    const modalInstance = $uibModal.open({
                        template: require('../../templates/common/modalPopup.html'),
                        controller: 'CommonModalPopupController',
                        windowClass: 'fade',
                        backdrop: 'static',
                        resolve: {
                            title() {
                                return gettextCatalog.getString('Unable to update user');
                            },
                            message() {
                                return response.data.exception;
                            }
                        }
                    });

                    modalInstance.result.then((result) => {}, () => {});
                    $scope.saving = false;
                }
            });
        } else {
            userManagementService.createUserPost($scope.form).then((response) => {
                if (response.status == 200) {
                    $uibModalInstance.close('done');
                    if (!$scope.roleRule.dontSendActivationEmail) {
                        $scope.sendActivateEmail(response.data.id);
                    }
                } else {
                    const modalInstance = $uibModal.open({
                        template: require('../../templates/common/modalPopup.html'),
                        controller: 'CommonModalPopupController',
                        windowClass: 'fade',
                        backdrop: 'static',
                        resolve: {
                            title() {
                                return gettextCatalog.getString('Unable to create user');
                            },
                            message() {
                                return response.data.exception;
                            }
                        }
                    });

                    modalInstance.result.then((result) => {}, () => {});
                    $scope.saving = false;
                }
            });
        }
    };

    $scope.sendActivateEmail = function(id) {
        const modalInstance = $uibModal.open({
            template: require('../../templates/common/modalDialog.html'),
            controller: 'commonModalDialogController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                title() {
                    return gettextCatalog.getString('Send activation e-mail');
                },
                confirmButtonName() {
                    return gettextCatalog.getString('Confirm');
                },
                confirmMsg() {
                    return gettextCatalog.getString('Would you like to send an activation email now?');
                },
                multiMsgArray() {
                    return [];
                }
            }
        });

        modalInstance.result.then((result) => {
            if (result == 'ok') {
                userManagementService.sendActivateEmail(id).then((response) => {
                    messageService.success(response.field);
                });
            } 
        }, () => {});
    };

    $scope.save = function() {
        $scope.saving = true;
    };

    $scope.cancel = function() {
        $uibModalInstance.close('cancel');
    };
    
    var getSelectedRole = function(rolename) {
    	let userRole = null;
    	angular.forEach($scope.roleList, (role) => {
    		if (role.rolename === rolename) {
    			userRole = role;
    		}
    	});
    	return userRole;
    };
    
    var getSelectedPartner = function(partner) {
    	let selectedPartner = null;
    	
    	if (partner != null) {
	    	angular.forEach($scope.partnerList, (partnerInList) => {
	    		if (partnerInList.id === partner.id) {
	    			selectedPartner = partnerInList;
	    		}
	    	});
    	}
    	
    	return selectedPartner;
    };
    
    var getSelectedMerchant = function(merchant) {
    	let selectedMerchant = null;
    	
    	if (merchant != null) {
	    	angular.forEach($scope.merchantList, (merchantInList) => {
	    		if (merchantInList.id === merchant.id) {
	    			selectedMerchant = merchantInList;
	    		}
	    	});
    	}
    	
    	return selectedMerchant;
    };
    
    var getSelectedOutlet = function(merchantLoc) {
    	let selectedOutlet = null;
    	
    	if (merchantLoc != null) {
	    	angular.forEach($scope.outletList, (outlet) => {
	    		if (outlet.id === merchantLoc.id) {
	    			selectedOutlet = outlet;
	    		}
	    	});
    	}
    	
    	return selectedOutlet;
    };
    
    var clearNonRequiredObjects = function() {
    	if (!$scope.roleRule.partnerRequired) {
    		$scope.form.partner = null;
    	}
    	
    	if (!$scope.roleRule.merchantRequired) {
    		$scope.form.merchant = null;
    	}
    	
    	if (!$scope.roleRule.outletRequired) {
    		$scope.form.outlet = null;
    	}
    };
    
    function getDefaultRoleRule() {
    	return {
    		partnerRequired: false,
    		merchantRequired: false,
    		outletRequired: false,
    		usernameAndPasswordOnly: false,
    		dontSendActivationEmail: false
    	};
    }

    $scope.isCamelCase = function(amICamelCase) {
        if (amICamelCase == null) {
            return false;
        }
        if (amICamelCase.toLowerCase() == amICamelCase) {
            return false;
        } else {
            return true;
        }
    };
});



// WEBPACK FOOTER //
// ./src/controllers/modal/usermanagement.edit.controller.js